import { useTranslation } from "react-i18next";
import hardwareImg from "@/assets/fabrica-taller-hd.png.asset.json";
import isoQuality from "@/assets/aenor-iso-9001.png.asset.json";
import isoEnvironment from "@/assets/aenor-iso-14001.png.asset.json";

const HardwareBand = () => {
  const { t } = useTranslation();
  return (
    <section data-header-theme="blue" className="relative w-full overflow-hidden bg-black">
      <img
        src={hardwareImg.url}
        alt={t("sHome.hardwareBand.alt")}
        className="h-[52vh] md:h-[85vh] w-full object-cover"
        loading="lazy"
      />

      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-black/40" />

      <div className="absolute inset-0 flex items-start justify-end p-4 sm:p-6 md:p-12">
        <p
          className="max-w-[14ch] text-right font-serif text-xl sm:text-2xl md:text-4xl lg:text-5xl font-normal leading-[1.12] tracking-[-0.01em] text-white"
        >
          {t("sHome.hardwareBand.headline")}
        </p>
      </div>

      <div className="absolute inset-x-0 bottom-0 flex items-end justify-start gap-3 p-4 sm:gap-4 sm:p-6 md:p-12">
        <img
          src={isoQuality.url}
          alt="AENOR Gestión de la Calidad ISO 9001"
          loading="lazy"
          className="h-20 w-auto sm:h-24 md:h-28"
        />
        <img
          src={isoEnvironment.url}
          alt="AENOR Gestión Ambiental ISO 14001"
          loading="lazy"
          className="h-20 w-auto sm:h-24 md:h-28"
        />
      </div>



    </section>
  );
};

export default HardwareBand;
